export const GET_TASK = 'GET_TASK_ELEMENT';
export const GET_ANSWER_INFO = 'GET_ANSWER_INFO_ELEMENT';
export const GET_TASKS = 'GET_TASK_ELEMENTS';
export const GET_SINGLE_TASK = 'GET_SINGLE_TASK_ELEMENT';
